"use client";

import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Cart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2551" id="cart-content" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="flex flex-col gap-6 mb-16 md:mb-20 max-w-3xl">
            <div className="flex items-center gap-4">
              <span className="font-default text-xs uppercase tracking-[0.25em] text-muted-foreground">
                Cart — Your Contribution
              </span>
              <span aria-hidden="true" className="h-px flex-1 max-w-[120px]" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            <h1 className="font-default font-semibold text-foreground text-[2.25rem] leading-[1.05] md:text-[3.5rem] tracking-tight">
              Your selected impact.
            </h1>

            <p className="font-default text-base md:text-lg text-muted-foreground max-w-xl leading-relaxed">
              Review the items you have chosen to support our mission. Every purchase helps keep awareness issues forever fresh in the minds of our community.
            </p>

            <div className="flex items-center gap-3 mt-2">
              <span className="font-default text-[0.65rem] uppercase tracking-[0.3em] text-muted-foreground">
                Ref / FF—CART—01
              </span>
              <span className="h-px w-8 bg-border" aria-hidden="true" />
              <span className="font-default text-[0.65rem] uppercase tracking-[0.3em] text-muted-foreground">
                Forever Fresh
              </span>
            </div>
          </div>

          {}
          <div className="h-px w-full bg-border mb-12 md:mb-16" aria-hidden="true" />

          {}
          <div className="prism-cart-wrapper">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}